import ResourceAdmin from "./ResourceAdmin";

const FIELDS = [
  { name: "name", label: "Name", type: "text", list: true },
  { name: "title", label: "Title / Role", type: "text", list: true },
  { name: "bio", label: "Bio", type: "textarea", rows: 4 },
  { name: "photo_url", label: "Photo URL", type: "text", list: true, listType: "image" },
  { name: "order", label: "Order", type: "number", default: 0 },
  { name: "is_published", label: "Published", type: "boolean", list: true, default: true },
];

export default function ImamsAdmin() {
  return <ResourceAdmin resource="imams" title="Imams" fields={FIELDS} />;
}
